import axios from 'axios';
import { token } from '../../../services/Apis';
import { juegosDeportivosApi } from '../../sistema/deportes/DeportesService';

export const RONDAS_CONST = 'rondas';

export const allRondasService = async (params) => {
  const res = await axios.get(`${juegosDeportivosApi}/${RONDAS_CONST}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveRondasService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(
      `${juegosDeportivosApi}/${RONDAS_CONST}/${id}`,
      data,
      {
        headers: token({}),
      },
    );
  } else {
    res = await axios.post(`${juegosDeportivosApi}/${RONDAS_CONST}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneRondasService = async (id) => {
  const res = await axios.get(`${juegosDeportivosApi}/${RONDAS_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteRondasService = async (id) => {
  const res = await axios.delete(
    `${juegosDeportivosApi}/${RONDAS_CONST}/${id}`,
    {
      headers: token({}),
    },
  );
  return res;
};
